










































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteDiagnosticoUsuarioStore from '@/components/Suporte/Store/SuporteDiagnosticoUsuarioStore'
import CardServicoDiagnostico from '@/components/Suporte/components/CardServicoDiagnostico.vue'
import CardConvitesDiagnostico from '@/components/Suporte/components/card-convites-diagnostico.vue'
import { cpfValido, emailValido, guidValido, normalizarCpf, SERVICOS, Servico, TipoBusca, TITULO_SERVICO } from '@/components/Suporte/diagnosticoUsuarioEngine'
import EventBus from '@/plugins/EventBus'

@Component({
  components: {
    CardServicoDiagnostico,
    CardConvitesDiagnostico,
  },
})
export default class ViewSuporteDiagnosticoUsuario extends Vue {
  // input local (sincronizado com o store via valorBusca)
  valorBuscaLocal: string = ''

  readonly tiposBusca = [
    { label: 'CPF', value: 'cpf' },
    { label: 'ID (UserId Keycloak)', value: 'id' },
    { label: 'E-mail', value: 'email' },
  ]

  readonly servicosOrdenados: Servico[] = SERVICOS

  get store() {
    return getModule(SuporteDiagnosticoUsuarioStore, this.$store)
  }

  get tipoBusca(): TipoBusca {
    return this.store.tipoBusca
  }

  get carregando() {
    return this.store.carregando
  }

  get consolidado() {
    return this.store.consolidado
  }

  get isBuscaComConvites(): boolean {
    return this.tipoBusca === 'cpf' || this.tipoBusca === 'email'
  }

  get falhasDeConsulta(): { origem: string; erro: string }[] {
    if (!this.consolidado) {
      return []
    }

    const falhasServicos = this.consolidado.registros
      .filter(r => r.status === 'indisponivel')
      .map(r => ({ origem: TITULO_SERVICO[r.servico], erro: r.erro || 'Falha ao consultar o serviço.' }))

    if (this.isBuscaComConvites && this.store.erroConvites) {
      return [...falhasServicos, { origem: 'Convites', erro: this.store.erroConvites }]
    }

    return falhasServicos
  }

  get camposDivergentesSet(): Set<string> {
    return this.store.camposDivergentes
  }

  get iconDoTipo() {
    if (this.tipoBusca === 'cpf') return 'mdi-card-account-details-outline'
    if (this.tipoBusca === 'id') return 'mdi-identifier'
    return 'mdi-email-outline'
  }

  get labelInput() {
    if (this.tipoBusca === 'cpf') return 'CPF (com ou sem formatação)'
    if (this.tipoBusca === 'id') return 'UserId GUID do Keycloak'
    return 'E-mail'
  }

  get entradaValida(): boolean {
    const v = (this.valorBuscaLocal || '').trim()
    if (!v) return false
    if (this.tipoBusca === 'cpf') return cpfValido(v)
    if (this.tipoBusca === 'id') return guidValido(v)
    return emailValido(v)
  }

  get erroValidacao(): string[] {
    const v = (this.valorBuscaLocal || '').trim()
    if (!v) return []
    if (this.tipoBusca === 'cpf' && !cpfValido(v)) return ['CPF inválido']
    if (this.tipoBusca === 'id' && !guidValido(v)) return ['ID inválido (esperado um GUID)']
    if (this.tipoBusca === 'email' && !emailValido(v)) return ['E-mail inválido']
    return []
  }

  registrosPorServico(srv: Servico) {
    if (!this.consolidado) return []
    return this.consolidado.registros.filter(r => r.servico === srv)
  }

  setTipoBusca(value: TipoBusca) {
    this.store.setTipoBusca(value)
    this.valorBuscaLocal = ''
  }

  limpar() {
    this.valorBuscaLocal = ''
    this.store.limpar()
  }

  @Watch('valorBuscaLocal')
  onValorLocalChange(v: string) {
    this.store.setValorBusca(v || '')
  }

  async buscar() {
    if (!this.entradaValida) return
    // Normaliza CPF antes de submeter (remove pontos/traços)
    let valor = (this.valorBuscaLocal || '').trim()
    if (this.tipoBusca === 'cpf') valor = normalizarCpf(valor)
    this.store.setValorBusca(valor)
    try {
      await this.store.executarBusca()
    } catch (err) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao executar a busca.',
        icon: 'warning',
        color: '#C62828',
      })
    }
  }

  beforeDestroy() {
    this.store.limpar()
  }
}
